export const findBreadcrumbMarker = (
  markers: Record<string, uui.domain.ui.map.markers.Breadcrumb>,
  breadcrumbId: string,
): uui.domain.ui.map.markers.Breadcrumb | undefined => {
  const marker = markers[breadcrumbId]

  return marker
}
